import React from 'react';
import "../../styles/devices/mob_PageTitle.css";

export function PageTitle(props) {
    return(
        <>
        <div className={`sig_MainPage_Title ${props.error===undefined ? "" : "sig_MainPage_Title_Error"}`}>
            <h1>{props.title}
                {props.img!==undefined ? (
                    <img style={{backgroundColor: "white", marginLeft: '20px', maxWidth: "40px", maxHeight: "40px"}} src={props.img} alt="icon"></img>
                ) : (
                    <> </>
                )}
            </h1>
            {props.error===undefined ? (
                <> </>
            ) : (
                <>
                    <hr></hr>
                    <h2>{props.error}</h2>
                </>
            )}
            {props.children}
        </div>
        </>
        
    );
}



